import { Button, Col, Row, Space, Typography } from "antd";
import { InputOTP } from "antd-input-otp";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { OnBoarding } from "~/Components";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post } from "~/Services";
const { Title, Text, Link } = Typography;
export const OtpPasswordPage = () => {
  const [inputValue, setInputValue] = useState<any>();
  const query = useQuery();
  const email = query.get("emailAddress");
  const [isLoading, setIsLoading] = useState(false);
  const { openToast } = useNotification();
  const navigate = useNavigate();
  const handleOtpVerification = () => {
    const payload = {
      email: email,
      code: Array.isArray(inputValue) ? inputValue.join("") : inputValue,
    };
    setIsLoading(true);
    post("auth/verify-otp", payload, { "X-Auth-Type": "manual" })
      .then((res: any) => {
        const message = res?.message;
        openToast({ content: message, type: "success" });
        navigate(`/auth/new-password?emailAddress=${email}`);
      })
      .catch((err) => {
        const message = err?.message;
        // openToast({ content: message, type: "error" });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleOtp = () => {
    post(`auth/request-otp?email=${email}`,null, { "X-Auth-Type": "manual" })
      .then((res: any) => {
        const message = res?.message;
        openToast({ content: message, type: "success" });
      })
      .catch((err) => {
        const message = err?.message;
        // openToast({ content: "message", type: "error" });
      });
  };

  return (
    <>
      <OnBoarding>
        <div style={{ width: "340px" }}>
          <Row style={{ marginBottom: 25 }}>
            <Col span={24}>
              <Title level={2}>OTP Verification</Title>
              <Text>Please verify your Otp</Text>
            </Col>
          </Row>
          <Row>
            <Space
              direction="vertical"
              size={16}
            >
              <InputOTP
                type="text"
                inputType="numeric"
                value={inputValue}
                onChange={(e) => setInputValue(e)}
              />
            </Space>
          </Row>
          <Row style={{ marginTop: 10, justifySelf: "end" }}>
            <Col span={24}>
              {" "}
              <Link onClick={handleOtp}>Resend Otp</Link>
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Button
              loading={isLoading}
              type="primary"
              block
              size="large"
              htmlType="submit"
              onClick={handleOtpVerification}
              disabled={!inputValue || inputValue.length < 6}
            >
              Continue
            </Button>
          </Row>
        </div>
      </OnBoarding>
    </>
  );
};
